export type DateFilterState = {
  selectedDate: string;
};

export const DEFAULT_DATE_FILTER_VALUE = '';
